export default {
  // Expenses
  'finance.expenses.headerTitle': '财务明细管理',
  'finance.expenses.action.create': '新建财务明细',
  'finance.expenses.action.submitAudit': '提交审核',
  'finance.expenses.confirm.delete': '确定要删除这个财务明细吗？',
  'finance.expenses.confirm.batchDelete': '确定要批量删除选中的财务明细吗？',
  'finance.expenses.confirm.batchDeleteDesc': '将删除选中的 {count} 条财务明细，此操作不可撤销',
  'finance.expenses.action.batchRevertAudit': '批量撤销',
  'finance.expenses.confirm.batchRevertAudit': '确定要批量撤销选中的已审核财务明细吗？',
  'finance.expenses.confirm.batchRevertAuditDesc':
    '将撤销选中的 {count} 条已审核财务明细，状态将恢复为待审核',
  'finance.expenses.message.batchRevertAudit.success': '批量撤销成功',
  'finance.expenses.message.batchRevertAudit.failed': '批量撤销失败',
  'finance.expenses.message.batchRevertAudit.noCode': '选中记录缺少编号，无法撤销',
  'finance.expenses.message.getDetailFailed': '获取财务明细详情失败',
  'finance.expenses.message.generateCodeFailed': '生成编号失败',
  'finance.expenses.message.update.success': '更新财务明细成功',
  'finance.expenses.message.update.failed': '更新财务明细失败',
  'finance.expenses.message.create.success': '创建财务明细成功',
  'finance.expenses.message.create.failed': '创建财务明细失败',
  'finance.expenses.error.loadTypeDict': '获取明细类型字典失败',
  'finance.expenses.message.selectForAudit': '请选择要提交审核的财务明细',
  'finance.expenses.audit.defaultName': '财务明细审核（{count}笔）',
  'finance.expenses.message.submitAudit.success': '提交审核成功',
  'finance.expenses.message.submitAudit.failed': '提交审核失败',
  'finance.expenses.column.code': '编号',
  'finance.expenses.column.name': '明细名称',
  'finance.expenses.column.type': '明细类型',
  'finance.expenses.column.projectName': '项目名称',
  'finance.expenses.column.relatedProject': '关联项目',
  'finance.expenses.column.bankStatement': '银行账单',
  'finance.expenses.column.expenseDate': '花销日期',
  'finance.expenses.column.checkNo': '支票号',
  'finance.expenses.column.amount': '金额',
  'finance.expenses.column.houseNo': '房号',
  'finance.expenses.column.parkingNo': '车位号',
  'finance.expenses.column.dateRange': '时间范围',
  'finance.expenses.column.status': '状态',
  'finance.expenses.column.checkNo': '支票号',
  'finance.expenses.column.applyReason': '申请说明',
  'finance.expenses.column.remarks': '备注',
  'finance.expenses.status.draft': '草稿',
  'finance.expenses.status.pending': '待审批',
  'finance.expenses.status.approved': '已通过',
  'finance.expenses.status.rejected': '已拒绝',
  'finance.expenses.modal.detailTitle': '财务明细详情',
  'finance.expenses.label.code': '编号',
  'finance.expenses.label.name': '明细名称',
  'finance.expenses.label.type': '明细类型',
  'finance.expenses.label.amount': '金额',
  'finance.expenses.label.status': '状态',
  'finance.expenses.label.applicantBy': '提交人',
  'finance.expenses.label.applyUser': '申请人',
  'finance.expenses.label.payeeUser': '受益人',
  'finance.expenses.label.projectName': '项目名称',
  'finance.expenses.label.applyReason': '申请说明',
  'finance.expenses.label.auditBy': '审核人ID',
  'finance.expenses.label.auditReason': '审核说明',
  'finance.expenses.label.relatedFile': '相关文件',
  'finance.expenses.label.remarks': '备注',
  'finance.expenses.label.baseAmount': '支出',
  'finance.expenses.label.ewtAmount': 'EWT金额',
  'finance.expenses.label.ctoAmount': 'CTO税金额',
  'finance.expenses.label.checkAmount': '支票金额',
  'finance.expenses.label.checkNo': '支票号',
  'finance.expenses.label.writeOffAmount': '核销金额',
  'finance.expenses.label.amountType': '收支类型',
  'finance.expenses.label.paymentAmount': '支付金额',
  'finance.expenses.label.inputTax': 'INPUT TAX',
  'finance.expenses.label.outputTax': 'OUTPUT TAX',
  'finance.expenses.label.receiptAttachment': '单据附件',
  'finance.expenses.placeholder.paymentAmount': '请输入支付金额',
  'finance.expenses.placeholder.ewtAmount': '请输入EWT金额',
  'finance.expenses.placeholder.ctoAmount': '请输入CTO税金额',
  'finance.expenses.placeholder.inputTax': '请输入INPUT TAX',
  'finance.expenses.placeholder.outputTax': '请输入OUTPUT TAX',
  'finance.expenses.placeholder.checkNo': '请输入支票号',
  'finance.expenses.rule.paymentAmountRequired': '请输入支付金额',
  'finance.expenses.section.amountDetail': '金额详情',
  'finance.expenses.form.expenseName.label': '费用名称',
  'finance.expenses.form.expenseName.placeholder': '例如：2026年2月物业电梯定期维护费',
  'finance.expenses.form.expenseName.required': '请输入名称',
  'finance.expenses.form.expenseName.max': '名称长度不能超过100个字符',
  'finance.expenses.form.payee.label': '收款人',
  'finance.expenses.form.payee.placeholder': '请输入收款人',
  'finance.expenses.form.detailDescription.label': '详细说明',
  'finance.expenses.form.detailDescription.placeholder': '请在此录入详细说明信息...',
  'finance.expenses.form.detailDescription.max': '申请原因长度不能超过500个字符',
  'finance.expenses.form.remarkInfo.label': '备注信息',
  'finance.expenses.form.remarkInfo.placeholder': '请输入备注信息',
  'finance.expenses.form.remarkInfo.max': '备注长度不能超过500个字符',
  'finance.expenses.action.uploading': '上传中...',
  'finance.expenses.action.uploadAttachment': '上传附件',
  'finance.expenses.action.viewFile': '查看文件',
  'finance.expenses.action.delete': '删除',
  'finance.expenses.upload.supportTip': '支持 PDF、Word、Excel、图片等格式，单个文件不超过 10MB',
  'finance.expenses.message.uploadTypeLimit': '只能上传 PDF、Word、Excel、TXT 或图片文件!',
  'finance.expenses.message.uploadSizeLimit': '文件大小不能超过10MB!',
  'finance.expenses.type.other': '其他',
  'finance.expenses.tax.ewt': 'EWT',
  'finance.expenses.tax.cto': 'CTO',
  'finance.expenses.tax.inputTax': 'INPUT TAX',
  'finance.expenses.tax.outputTax': 'OUTPUT TAX',
  'finance.expenses.section.auditRecords': '审核记录',
  'finance.expenses.loading': '加载中...',
  'finance.expenses.empty.auditRecords': '暂无审核记录',
  'finance.expenses.modal.submitAuditTitle': '提交审核',
  'finance.expenses.drawer.title.edit': '编辑财务明细',
  'finance.expenses.drawer.title.create': '新增财务明细',
  'finance.expenses.form.auditName.label': '审核名称',
  'finance.expenses.form.auditName.placeholder': '请输入审核名称',
  'finance.expenses.form.auditName.required': '请输入审核名称',
  'finance.expenses.form.submitRemark.label': '提交说明',
  'finance.expenses.form.submitRemark.placeholder': '请输入提交说明（可选）',
  'finance.expenses.selectedBills': '选中的财务明细列表（共 {count} 条）',
  'finance.expenses.form.code.label': '编号',
  'finance.expenses.form.code.placeholder': '请输入编号',
  'finance.expenses.form.code.required': '请输入编号',
  'finance.expenses.form.code.max': '编号长度不能超过100个字符',
  'finance.expenses.form.name.label': '明细名称',
  'finance.expenses.form.name.placeholder': '请输入明细名称',
  'finance.expenses.form.name.required': '明细名称为必填项',
  'finance.expenses.form.name.max': '明细名称长度不能超过100个字符',
  'finance.expenses.form.type.label': '明细类型',
  'finance.expenses.form.type.placeholder': '请选择明细类型',
  'finance.expenses.form.type.required': '请选择明细类型',
  'finance.expenses.form.amount.label': '金额',
  'finance.expenses.form.amount.placeholder': '请输入金额',
  'finance.expenses.form.amount.required': '请输入金额',
  'finance.expenses.form.amount.min': '金额不能小于0',
  'finance.expenses.form.bankStatement.label': '银行账单',
  'finance.expenses.form.bankStatement.placeholder': '请搜索并选择银行账单',
  'finance.expenses.form.projectName.label': '项目名称',
  'finance.expenses.form.projectName.placeholder': '请选择项目名称',
  'finance.expenses.form.applyUser.label': '申请人',
  'finance.expenses.form.applyUser.placeholder': '请输入申请人',
  'finance.expenses.form.applyUser.max': '申请人长度不能超过100个字符',
  'finance.expenses.form.payeeUser.label': '受益人',
  'finance.expenses.form.payeeUser.placeholder': '请输入受益人',
  'finance.expenses.form.payeeUser.max': '受益人长度不能超过100个字符',
  'finance.expenses.form.applyReason.label': '申请说明',
  'finance.expenses.form.applyReason.placeholder': '请输入申请说明',
  'finance.expenses.form.applyReason.max': '申请说明长度不能超过500个字符',
  'finance.expenses.form.remarks.label': '备注',
  'finance.expenses.form.remarks.placeholder': '请输入备注信息',
  'finance.expenses.form.remarks.max': '备注长度不能超过500个字符',
  'finance.expenses.placeholder.startDate': '开始日期',
  'finance.expenses.placeholder.endDate': '结束日期',
  'finance.expenses.category.dailyExpense': '日常花费',
  'finance.expenses.category.realEstate': '不动产明细',
  'finance.expenses.category.propertyFee': '物业费明细',
  'finance.expenses.drawer.title.editExpense': '编辑费用',
  'finance.expenses.drawer.title.createExpense': '新建费用',
  'finance.expenses.board.title': '费用录入看板',
  'finance.expenses.board.category': '费用分类',
  'finance.expenses.amountType.in': '收入',
  'finance.expenses.amountType.out': '支出',
  'finance.expenses.label.businessDate': '业务日期',
  'finance.expenses.section.relatedLocation': '关联位置信息',
  'finance.expenses.label.relatedProject': '关联项目',
  'finance.expenses.label.expenseType': '费用类型',
  'finance.expenses.placeholder.relatedProject': '请选择关联项目',
  'finance.expenses.placeholder.expenseType': '请选择费用类型',
  'finance.expenses.section.coreDetail': '核心费用详情',
  'finance.expenses.section.attachmentRemark': '附件与备注',
  'finance.expenses.section.basic': '基本信息',
  'finance.expenses.section.apply': '申请信息',
  'finance.expenses.section.relatedFile': '相关文件',
  'finance.expenses.section.other': '其他信息',
  'finance.expenses.section.bankStatement': '关联银行账单',
  'finance.expenses.tab.all': '全部数据',
  'finance.expenses.tab.byTime': '时间搜索',
  'finance.expenses.tab.byHouse': '房号搜索',
  'finance.expenses.tab.byParking': '车位号搜索',
  'finance.expenses.action.import': '明细数据导入',
  'finance.expenses.import.section.category': '费用分类',
  'finance.expenses.import.section.assetType': '不动产类型',
  'finance.expenses.import.section.actions': '导入操作',
  'finance.expenses.import.section.history': '导入历史',
  'finance.expenses.import.section.detail': '导入详情',
  'finance.expenses.import.category.daily': '日常花费',
  'finance.expenses.import.category.realEstate': '不动产明细',
  'finance.expenses.import.category.propertyFee': '物业费明细',
  'finance.expenses.import.template.realEstateHouse': '不动产明细-房屋',
  'finance.expenses.import.template.realEstateParking': '不动产明细-车位',
  'finance.expenses.import.template.propertyFeeHouse': '物业费明细-房屋',
  'finance.expenses.import.template.propertyFeeParking': '物业费明细-车位',
  'finance.expenses.import.assetType.house': '房屋',
  'finance.expenses.import.assetType.parking': '车位',
  'finance.expenses.import.action.importExcel': '导入 Excel',
  'finance.expenses.import.action.downloadTemplate': '下载{name}模板',
  'finance.expenses.import.action.importAll': '全部导入',
  'finance.expenses.import.action.exportExcel': '导出Excel',
  'finance.expenses.import.action.prevPage': '上一页',
  'finance.expenses.import.action.nextPage': '下一页',
  'finance.expenses.import.status.pending': '待导入',
  'finance.expenses.import.status.success': '导入成功',
  'finance.expenses.import.status.failed': '导入失败',
  'finance.expenses.import.stats.total': '全部',
  'finance.expenses.import.stats.success': '成功',
  'finance.expenses.import.stats.pending': '待导入',
  'finance.expenses.import.stats.failed': '失败',
  'finance.expenses.import.pagination.simple': '共 {total} 条 · 第 {page} 页',
  'finance.expenses.import.unnamedFile': '未命名文件',
  'finance.expenses.import.column.date': '日期',
  'finance.expenses.import.column.relatedProject': '关联项目',
  'finance.expenses.import.column.expenseType': '费用类型',
  'finance.expenses.import.column.houseInfo': '房屋信息',
  'finance.expenses.import.column.parkingInfo': '车位信息',
  'finance.expenses.import.edit.title': '编辑导入数据',
  'finance.expenses.import.edit.success': '编辑成功',
  'finance.expenses.import.edit.failed': '编辑失败',
  'finance.expenses.import.edit.copyEmpty': '请先选择内容',
  'finance.expenses.import.edit.copySuccess': '已复制: {text}',
  'finance.expenses.import.edit.copyFailed': '复制失败',
  'finance.expenses.import.column.amount': '金额',
  'finance.expenses.import.column.error': '错误信息',
  'finance.expenses.import.label.dataStatus': '数据状态',
  'finance.expenses.import.label.building': '楼栋',
  'finance.expenses.import.label.floor': '楼层',
  'finance.expenses.import.label.roomNumber': '房号',
  'finance.expenses.import.label.income': '收入',
  'finance.expenses.import.label.expense': '支出',
  'finance.expenses.import.label.checkAmount': '核对金额',
  'finance.expenses.import.label.checkNo': '支票号',
  'finance.expenses.import.label.bankStatement': '银行对账单',
  'finance.expenses.import.empty.selectRecord': '请从左侧选择一条导入记录查看详情',
  'finance.expenses.import.modal.detailTitle': '导入数据详情',
  'finance.expenses.import.modal.errorDetailTitle': '错误详情',
  'finance.expenses.import.message.templateDownloadSuccess': '模板下载成功',
  'finance.expenses.import.message.uploading': '正在上传文件...',
  'finance.expenses.import.message.uploadSuccess': '文件上传成功',
  'finance.expenses.import.message.uploadFailed': '文件上传失败',
  'finance.expenses.import.message.uploadFailedRetry': '文件上传失败，请重试',
  'finance.expenses.import.message.unknownCategory': '未知的分类类型',
  'finance.expenses.import.message.selectRecordFirst': '请先选择导入记录',
  'finance.expenses.import.message.exporting': '正在导出数据...',
  'finance.expenses.import.message.exportSuccess': '数据导出成功',
  'finance.expenses.import.message.exportFailed': '数据导出失败',
  'finance.expenses.import.message.exportFailedRetry': '数据导出失败，请重试',
  'finance.expenses.import.message.importing': '正在导入数据...',
  'finance.expenses.import.message.importStarted': '数据正在导入中，请稍后查看',
  'finance.expenses.import.message.importFailed': '数据导入失败',
  'finance.expenses.import.message.importFailedRetry': '数据导入失败，请重试',
  'finance.expenses.action.createDetail': '新建费用明细',
  'finance.expenses.action.financialDeclare': '财务申报',
  'finance.expenses.action.exportExcel': '导出Excel',
  'finance.expenses.action.configShort': '配置',
  'finance.expenses.summary.currentPage': '本页统计',
  'finance.expenses.summary.allPages': '全部统计',
  'finance.expenses.message.bankStatementNotFound': '银行账单信息加载失败',
  'finance.expenses.action.upload': '点击上传相关文件',
  'finance.expenses.action.downloadOriginal': '下载原文件',
  'finance.bankStatement.headerTitle': '银行账单管理',
  'finance.bankStatement.pageTitle': '银行账单',
  'finance.bankStatement.action.create': '新建银行账单',
  'finance.bankStatement.action.batchCreate': '批量创建',
  'finance.bankStatement.action.upload': '点击上传账单文件',
  'finance.bankStatement.action.downloadOriginal': '下载原文件',
  'finance.bankStatement.confirm.delete': '确定要删除这个银行账单吗？',
  'finance.bankStatement.confirm.batchDelete':
    '确定要批量删除选中的银行账单吗？',
  'finance.bankStatement.message.getDetailFailed': '获取银行账单详情失败',
  'finance.bankStatement.message.generateNoFailed': '生成账单编号失败',
  'finance.bankStatement.message.pleaseUpload': '请上传账单文件',
  'finance.bankStatement.message.update.success': '更新银行账单成功',
  'finance.bankStatement.message.update.failed': '更新银行账单失败',
  'finance.bankStatement.message.create.success': '创建银行账单成功',
  'finance.bankStatement.message.create.failed': '创建银行账单失败',
  'finance.bankStatement.message.batchCreate.success': '批量创建成功',
  'finance.bankStatement.message.batchCreate.failed': '批量创建失败',
  'finance.bankStatement.message.selectBillingPeriod': '请选择账期',
  'finance.bankStatement.column.billingPeriod': '账期',
  'finance.bankStatement.column.statementNo': '账单编号',
  'finance.bankStatement.column.bank': '银行',
  'finance.bankStatement.column.monthBegAmount': '月初金额',
  'finance.bankStatement.column.totalIncome': '总收入',
  'finance.bankStatement.column.totalExpense': '总支出',
  'finance.bankStatement.column.status': '结算状态',
  'finance.bankStatement.column.remarks': '备注',
  'finance.bankStatement.status.settled': '已结算',
  'finance.bankStatement.status.unsettled': '未结算',
  'finance.bankStatement.label.statementNo': '账单编号',
  'finance.bankStatement.label.bank': '银行',
  'finance.bankStatement.label.billingPeriod': '账期',
  'finance.bankStatement.label.monthBegAmount': '月初金额',
  'finance.bankStatement.label.totalIncome': '总收入',
  'finance.bankStatement.label.totalExpense': '总支出',
  'finance.bankStatement.label.pdfKey': 'PDF秘钥',
  'finance.bankStatement.label.statementFile': '账单文件',
  'finance.bankStatement.label.remarks': '备注',
  'finance.bankStatement.form.statementNo.label': '账单编号',
  'finance.bankStatement.form.statementNo.placeholder': '请输入账单编号',
  'finance.bankStatement.form.statementNo.required': '请输入账单编号',
  'finance.bankStatement.form.statementNo.max': '账单编号长度不能超过100个字符',
  'finance.bankStatement.form.statementNo.exists': '账单编号已存在，请修改',
  'finance.bankStatement.form.bank.label': '银行',
  'finance.bankStatement.form.bank.placeholder': '请选择银行',
  'finance.bankStatement.form.bank.required': '请选择银行',
  'finance.bankStatement.form.billingPeriod.label': '账期',
  'finance.bankStatement.form.billingPeriod.placeholder': '请选择账期',
  'finance.bankStatement.form.billingPeriod.required': '账期为必填项',
  'finance.bankStatement.form.pdfKey.label': 'PDF秘钥',
  'finance.bankStatement.form.pdfKey.placeholder': '请输入PDF秘钥',
  'finance.bankStatement.form.pdfKey.max': 'PDF秘钥长度不能超过200个字符',
  'finance.bankStatement.form.monthBegAmount.label': '月初金额',
  'finance.bankStatement.form.monthBegAmount.placeholder': '请输入月初金额',
  'finance.bankStatement.form.monthBegAmount.invalid': '请输入有效的金额',
  'finance.bankStatement.form.remarks.label': '备注',
  'finance.bankStatement.form.remarks.placeholder': '请输入备注信息',
  'finance.bankStatement.form.remarks.max': '备注长度不能超过500个字符',
  'finance.bankStatement.section.basic': '基本信息',
  'finance.bankStatement.section.amount': '金额信息',
  'finance.bankStatement.section.statementFile': '账单文件',
  'finance.bankStatement.section.other': '其他信息',
  'finance.bankStatement.drawer.title.edit': '编辑银行账单',
  'finance.bankStatement.drawer.title.create': '新增银行账单',
  'finance.bankStatement.modal.detailTitle': '银行账单详情',
  'finance.bankStatement.modal.batchCreateTitle': '批量创建银行账单',
  'finance.bankStatement.batchCreate.tip': '将为所有银行创建指定账期的账单',
  // 本模块内通用兜底键
  'common.column.action': '操作',
  'common.action.view': '查看',
  'common.action.edit': '编辑',
  'common.action.delete': '删除',
  'common.action.batchDelete': '批量删除',
  'common.action.ok': '确定',
  'common.action.cancel': '取消',
  'common.action.search': '搜索',
  'common.action.reset': '重置',
  'common.action.close': '关闭',
  'common.action.audit': '审核',
  'common.action.downloadFile': '下载文件',
  'common.all': '全部',
  'common.label.fileFormat': '文件格式：',
  'common.label.fileSize': '文件大小：',
  'common.label.fileName': '文件名：',
  'common.label.createdBy': '创建人',
  'common.label.createdTime': '创建时间',
  'common.label.updatedTime': '更新时间',
  'common.table.selected': '已选择 {count} 项',
  'common.table.clearSelected': '取消选择',
  'common.message.delete.success': '删除成功',
  'common.message.delete.failed': '删除失败',
  'common.message.batchDelete.success': '批量删除成功',
  'common.message.batchDelete.failed': '批量删除失败',
  'common.message.upload.success': '文件上传成功',
  'common.message.upload.failed': '文件上传失败',
  'common.upload.invalidType': '只能上传 PDF、Word、Excel 或 TXT 文件!',
  'common.upload.tooLarge': '文件大小不能超过10MB!',
  'common.upload.uploading': '上传中',
  'common.message.operation.failed': '操作失败',
  'common.validating': '验证中...',
  'common.add': '新增',
  'common.view': '查看',
  'common.edit': '编辑',
  'common.delete': '删除',
  'common.createTime': '创建时间',
  'common.action': '操作',
  'common.required': '此项为必填项',
  'common.deleteSuccess': '删除成功',
  'common.deleteFailed': '删除失败',
  'common.createSuccess': '创建成功',
  'common.updateSuccess': '更新成功',
  'common.saveFailed': '保存失败',
  'common.loadFailed': '加载失败',
  'common.deleteConfirm': '确定要删除吗？',
  'common.yes': '是',
  'common.no': '否',
  'common.batchDelete': '批量删除',
  'common.selected': '已选择',
  'common.item': '项',
  'common.cancel': '取消',
  'common.emailInvalid': '邮箱格式不正确',
  'common.enabled': '启用',
  'common.disabled': '禁用',
  'common.passwordMismatch': '两次输入的密码不一致',
  // Mortgage Pay
  'finance.mortgagePay.headerTitle': '房贷还款管理',
  'finance.mortgagePay.tab.mortgage': '房贷还款',
  'finance.mortgagePay.tab.car': '车位还款',
  'finance.mortgagePay.action.create': '新建还款',
  'finance.mortgagePay.action.upload': '点击上传附件',
  'finance.mortgagePay.action.downloadOriginal': '下载原文件',
  'finance.mortgagePay.action.searchHouse': '查询',
  'finance.mortgagePay.action.submitAudit': '提交审核',
  'finance.mortgagePay.confirm.delete': '确定要删除这个还款记录吗？',
  'finance.mortgagePay.confirm.batchDelete': '确定要批量删除选中的还款记录吗？',
  'finance.mortgagePay.message.getDetailFailed': '获取还款详情失败',
  'finance.mortgagePay.message.generateCodeFailed': '生成还款编号失败',
  'finance.mortgagePay.message.update.success': '更新还款记录成功',
  'finance.mortgagePay.message.update.failed': '更新还款记录失败',
  'finance.mortgagePay.message.create.success': '创建还款记录成功',
  'finance.mortgagePay.message.create.failed': '创建还款记录失败',
  'finance.mortgagePay.column.billingPeriod': '账期',
  'finance.mortgagePay.column.type': '类型',
  'finance.mortgagePay.column.code': '还款编号',
  'finance.mortgagePay.column.houseInfo': '房屋信息',
  'finance.mortgagePay.column.bank': '银行',
  'finance.common.column.bankTransaction': '银行流水',
  'finance.common.bankTransaction.matched': '已匹配',
  'finance.common.bankTransaction.matchedWithCount': '已匹配 ({count})',
  'finance.common.bankTransaction.unmatched': '未匹配',
  'finance.common.bankTransaction.detailTitle': '银行流水详情',
  'finance.common.bankTransaction.noData': '暂无银行流水数据',
  'finance.common.bankTransaction.itemTitle': '流水 {index}',
  'finance.common.bankTransaction.section.bankStatement': '关联银行账单',
  'finance.common.bankTransaction.section.transaction': '流水明细',
  'finance.common.bankTransaction.matchType': '匹配方式',
  'finance.common.bankTransaction.matchType.auto': '自动匹配',
  'finance.common.bankTransaction.matchType.manual': '手动匹配',
  'finance.common.bankTransaction.assetCode': '关联编号',
  'finance.mortgagePay.column.amount': '还款金额',
  'finance.mortgagePay.column.status': '状态',
  'finance.mortgagePay.column.remarks': '备注',
  'finance.mortgagePay.modal.detailTitle': '房贷还款详情',
  'finance.mortgagePay.label.code': '还款编号',
  'finance.mortgagePay.label.billingPeriod': '账期',
  'finance.mortgagePay.label.type': '类型',
  'finance.mortgagePay.label.amount': '还款金额',
  'finance.mortgagePay.label.bank': '银行',
  'finance.mortgagePay.label.status': '状态',
  'finance.mortgagePay.label.houseInfo': '房屋信息',
  'finance.mortgagePay.label.ownerInfo': '房主信息',
  'finance.mortgagePay.label.email': '邮箱',
  'finance.mortgagePay.label.ownerId': '业主ID',
  'finance.mortgagePay.label.attachment': '附件文件',
  'finance.mortgagePay.label.remarks': '备注',
  'finance.mortgagePay.section.houseOwner': '房屋与业主信息',
  'finance.mortgagePay.section.attachment': '附件',
  'finance.mortgagePay.section.basic': '基本信息',
  'finance.mortgagePay.section.other': '其他信息',
  'finance.mortgagePay.section.auditRecords': '审核记录',
  'finance.mortgagePay.drawer.title.edit': '编辑房贷还款',
  'finance.mortgagePay.drawer.title.create': '新增房贷还款',
  'finance.mortgagePay.form.code.label': '还款编号',
  'finance.mortgagePay.form.code.placeholder': '请输入还款编号',
  'finance.mortgagePay.form.code.required': '请输入还款编号',
  'finance.mortgagePay.form.code.max': '编号长度不能超过100个字符',
  'finance.mortgagePay.form.repaymentType.label': '还款类型',
  'finance.mortgagePay.form.repaymentType.required': '请选择还款类型',
  'finance.mortgagePay.form.billingPeriod.label': '账期',
  'finance.mortgagePay.form.billingPeriod.placeholder': '请选择账期',
  'finance.mortgagePay.form.billingPeriod.required': '账期为必填项',
  'finance.mortgagePay.form.house.label': '房屋',
  'finance.mortgagePay.form.house.placeholder': '请选择房屋',
  'finance.mortgagePay.form.house.required': '请选择房屋',
  'finance.mortgagePay.form.parking.placeholder': '请选择车位',
  'finance.mortgagePay.form.owner.label': '业主',
  'finance.mortgagePay.form.owner.placeholder': '请选择房屋',
  'finance.mortgagePay.form.owner.required': '请选择房屋',
  'finance.mortgagePay.form.bank.label': '收款银行',
  'finance.mortgagePay.form.bank.placeholder': '请选择收款银行',
  'finance.mortgagePay.form.bank.required': '请选择收款银行',
  'finance.mortgagePay.form.amount.label': '还款金额',
  'finance.mortgagePay.form.amount.placeholder': '请输入还款金额',
  'finance.mortgagePay.form.amount.required': '请输入还款金额',
  'finance.mortgagePay.form.amount.min': '金额不能小于0',
  'finance.mortgagePay.form.remarks.label': '备注',
  'finance.mortgagePay.form.remarks.placeholder': '请输入备注信息',
  'finance.mortgagePay.form.remarks.max': '备注长度不能超过500个字符',
  'finance.mortgagePay.form.bankStatement.label': '银行账单',
  'finance.mortgagePay.form.bankStatement.placeholder': '请搜索并选择银行账单',
  'finance.mortgagePay.section.bankStatement': '关联银行账单',
  'finance.mortgagePay.message.bankStatementNotFound': '银行账单信息加载失败',
  'finance.mortgagePay.loading': '加载中...',
  'finance.mortgagePay.message.selectForAudit': '请先选择要提交审核的还款记录',
  'finance.mortgagePay.message.submitAudit.success': '提交审核成功',
  'finance.mortgagePay.message.submitAudit.failed': '提交审核失败',
  'finance.mortgagePay.modal.submitAuditTitle': '提交审核',
  'finance.mortgagePay.form.auditName.label': '审核名称',
  'finance.mortgagePay.form.auditName.placeholder': '请输入审核名称',
  'finance.mortgagePay.form.auditName.required': '请输入审核名称',
  'finance.mortgagePay.form.submitRemark.label': '提交说明',
  'finance.mortgagePay.form.submitRemark.placeholder': '请输入提交说明（选填）',
  'finance.mortgagePay.selectedBills': '已选择 {count} 条还款记录',
  'finance.mortgagePay.audit.defaultName': '房贷还款批量审核（{count}条）',
  'finance.mortgagePay.status.draft': '草稿',
  'finance.mortgagePay.status.pending': '待审批',
  'finance.mortgagePay.status.approved': '已通过',
  'finance.mortgagePay.status.rejected': '已拒绝',
  'finance.mortgagePay.status.overdue': '逾期',
  'finance.mortgagePay.type.rent': '月租',
  'finance.mortgagePay.type.mortgage': '月供',
  'finance.mortgagePay.empty.auditRecords': '暂无审核记录',
  'finance.mortgagePay.empty.bankStatement': '暂无关联银行账单',
  'finance.mortgagePay.summary.houseInfo': '房屋信息',
  'finance.mortgagePay.summary.amount': '还款金额',
  'finance.mortgagePay.action.batchCreate': '批量还款',
  'finance.mortgagePay.modal.batchCreateTitle': '批量创建还款记录',
  'finance.mortgagePay.message.batchCreate.success':
    '批量创建成功，共创建 {count} 条记录',
  'finance.mortgagePay.message.batchCreate.completed':
    '批量创建完成，共创建 {count} 条记录',
  'finance.mortgagePay.message.batchCreate.processing':
    '批量创建任务已提交，数据正在后台处理中，请稍后刷新查看结果...',
  'finance.mortgagePay.message.batchCreate.failed': '批量创建失败',
  'finance.mortgagePay.batchCreate.description.title': '说明：',
  'finance.mortgagePay.batchCreate.description.content':
    '系统将根据指定账期查询已出售和已出租的房屋，为不存在记录的房屋创建草稿状态的还款记录。',
  'finance.mortgagePay.batchCreate.tab.single': '单笔创建',
  'finance.mortgagePay.batchCreate.tab.range': '批量创建',
  'finance.mortgagePay.form.periodRange.label': '账期范围',
  'finance.mortgagePay.form.periodRange.required': '请选择账期范围',
  'finance.mortgagePay.batchCreate.progress': '正在处理 {period}（{current}/{total}）',
  'finance.mortgagePay.message.batchCreate.rangeSuccess': '批量创建完成，共处理 {count} 个账期',
  'finance.mortgagePay.message.batchCreate.partialFailed':
    '部分账期创建失败，成功 {success} 个，失败账期：{failed}',
  'finance.mortgagePay.message.batchCreate.invalidRange': '请选择有效的账期范围',
  // Car Pay
  'finance.carPay.pageTitle': '车贷还款',
  'finance.carPay.pageSubTitle': '车贷还款管理',
  'finance.carPay.headerTitle': '车贷还款管理',
  'finance.carPay.action.create': '新建还款',
  'finance.carPay.action.upload': '点击上传附件',
  'finance.carPay.action.downloadOriginal': '下载原文件',
  'finance.carPay.action.searchParking': '查询',
  'finance.carPay.action.submitAudit': '提交审核',
  'finance.carPay.confirm.delete': '确定要删除这个还款记录吗？',
  'finance.carPay.confirm.batchDelete': '确定要批量删除选中的还款记录吗？',
  'finance.carPay.message.getDetailFailed': '获取还款详情失败',
  'finance.carPay.message.generateCodeFailed': '生成还款编号失败',
  'finance.carPay.message.update.success': '更新还款记录成功',
  'finance.carPay.message.update.failed': '更新还款记录失败',
  'finance.carPay.message.create.success': '创建还款记录成功',
  'finance.carPay.message.create.failed': '创建还款记录失败',
  'finance.carPay.column.billingPeriod': '账期',
  'finance.carPay.column.type': '类型',
  'finance.carPay.column.code': '还款编号',
  'finance.carPay.column.parkingInfo': '车位信息',
  'finance.carPay.column.repaymentType': '还款类型',
  'finance.carPay.column.projectName': '项目名称',
  'finance.carPay.column.bank': '银行',
  'finance.carPay.column.amount': '还款金额',
  'finance.carPay.column.status': '状态',
  'finance.carPay.column.remarks': '备注',
  'finance.carPay.detail.title': '车贷还款详情',
  'finance.carPay.modal.detailTitle': '车贷还款详情',
  'finance.carPay.label.code': '还款编号',
  'finance.carPay.label.billingPeriod': '账期',
  'finance.carPay.label.amount': '还款金额',
  'finance.carPay.label.bank': '银行',
  'finance.carPay.label.status': '状态',
  'finance.carPay.label.projectName': '项目名称',
  'finance.carPay.label.parkingInfo': '车位信息',
  'finance.carPay.label.ownerInfo': '车主信息',
  'finance.carPay.label.email': '邮箱',
  'finance.carPay.label.ownerId': '车主ID',
  'finance.carPay.label.attachment': '附件文件',
  'finance.carPay.label.auditRecord': '审核记录',
  'finance.carPay.label.remarks': '备注',
  'finance.carPay.section.basic': '基本信息',
  'finance.carPay.section.parkingOwner': '车位与车主信息',
  'finance.carPay.section.attachment': '附件',
  'finance.carPay.section.other': '其他信息',
  'finance.carPay.section.bankStatement': '关联银行账单',
  'finance.carPay.section.auditRecords': '审核记录',
  'finance.carPay.section.remark': '备注',
  'finance.carPay.loading': '加载中...',
  'finance.carPay.empty.auditRecords': '暂无审核记录',
  'finance.carPay.message.bankStatementNotFound': '银行账单信息加载失败',
  'finance.carPay.drawer.title.edit': '编辑车贷还款',
  'finance.carPay.drawer.title.create': '新增车贷还款',
  'finance.carPay.form.code.label': '还款编号',
  'finance.carPay.form.code.placeholder': '请输入还款编号',
  'finance.carPay.form.code.required': '请输入还款编号',
  'finance.carPay.form.code.max': '编号长度不能超过100个字符',
  'finance.carPay.form.billingPeriod.label': '账期',
  'finance.carPay.form.billingPeriod.placeholder': '请选择账期',
  'finance.carPay.form.billingPeriod.required': '账期为必填项',
  'finance.carPay.form.parking.label': '车位',
  'finance.carPay.form.parking.placeholder': '请选择车位',
  'finance.carPay.form.parking.required': '请选择车位',
  'finance.carPay.form.type.label': '还款类型',
  'finance.carPay.form.type.placeholder': '请选择还款类型',
  'finance.carPay.form.type.required': '请选择还款类型',
  'finance.carPay.form.ownerName.label': '车位所有者',
  'finance.carPay.form.ownerName.placeholder': '车位所有者',
  'finance.carPay.form.bank.label': '收款银行',
  'finance.carPay.form.bank.placeholder': '请选择收款银行',
  'finance.carPay.form.bank.required': '请选择收款银行',
  'finance.carPay.form.amount.label': '还款金额',
  'finance.carPay.form.amount.placeholder': '请输入还款金额',
  'finance.carPay.form.amount.required': '请输入还款金额',
  'finance.carPay.form.amount.min': '金额不能小于0',
  'finance.carPay.form.bankStatement.label': '关联银行账单',
  'finance.carPay.form.bankStatement.placeholder': '请选择关联银行账单',
  'finance.carPay.form.remark.label': '备注',
  'finance.carPay.form.remark.placeholder': '请输入备注信息',
  'finance.carPay.form.remark.max': '备注长度不能超过500个字符',
  'finance.carPay.form.attachment.label': '附件',
  'finance.carPay.form.attachment.upload': '上传附件',
  'finance.carPay.upload.multipleSupport': '支持多文件上传，可同时选择多个文件',
  'finance.carPay.message.paymentTypeChanged': '还款类型已更改，请重新选择车位以更新金额',
  'finance.carPay.message.selectForAudit': '请先选择要提交审核的还款记录',
  'finance.carPay.message.submitAudit.success': '提交审核成功',
  'finance.carPay.message.submitAudit.failed': '提交审核失败',
  'finance.carPay.audit.title': '提交审核',
  'finance.carPay.modal.submitAuditTitle': '提交审核',
  'finance.carPay.audit.auditName': '审核名称',
  'finance.carPay.audit.auditName.required': '请输入审核名称',
  'finance.carPay.audit.remark': '提交说明',
  'finance.carPay.audit.defaultName': '车贷还款批量审核（{count}条）',
  'finance.carPay.form.auditName.label': '审核名称',
  'finance.carPay.form.auditName.placeholder': '请输入审核名称',
  'finance.carPay.form.auditName.required': '请输入审核名称',
  'finance.carPay.form.submitRemark.label': '提交说明',
  'finance.carPay.form.submitRemark.placeholder': '请输入提交说明',
  'finance.carPay.selectedBills': '已选择 {count} 条还款记录',
  'finance.carPay.status.draft': '草稿',
  'finance.carPay.status.pending': '待审批',
  'finance.carPay.status.approved': '已通过',
  'finance.carPay.status.rejected': '已拒绝',
  'finance.carPay.status.overdue': '逾期',
  'finance.carPay.type.rent': '月租',
  'finance.carPay.type.mortgage': '月供',
  'finance.carPay.action.batchCreate': '批量还款',
  'finance.carPay.modal.batchCreateTitle': '批量创建车贷还款记录',
  'finance.carPay.message.batchCreate.success':
    '批量创建成功，共创建 {count} 条记录',
  'finance.carPay.message.batchCreate.failed': '批量创建失败',
  'finance.carPay.batchCreate.description.title': '说明：',
  'finance.carPay.batchCreate.description.content':
    '系统将根据指定账期查询已出售和已出租的车位，为不存在记录的车位创建草稿状态的还款记录。',
  // Property Review (Repayment Audit)
  'audit.propertyReview.headerTitle': '贷款待审核',
  'audit.propertyReview.subTitle': '房贷和车贷还款审核管理',
  // Property Reviewed (Repayment Audited)
  'audit.propertyReviewed.headerTitle': '贷款已审核',
  'audit.propertyReviewed.subTitle': '房贷和车贷还款已审核记录',
  'audit.propertyReviewed.pageSubTitle': '查看已审核的还贷记录',
  'audit.propertyReviewed.tableTitle': '还贷查询',
  // Search - Mortgage Statistics
  'search.mortgageStatistics.tab.mortgage': '房贷还款',
  'search.mortgageStatistics.tab.car': '车位还款',
  'search.mortgageStatistics.page.subTitle':
    '逾期统计自「最早未缴费记录的创建时间」起满 {days} 天后的日期开始累计逾期天数。',
  'search.mortgageStatistics.headerTitle.mortgage': '房贷逾期统计',
  'search.mortgageStatistics.headerTitle.car': '车位逾期统计',
  'search.mortgageStatistics.type.rent': '月租',
  'search.mortgageStatistics.type.mortgage': '房贷',
  'search.mortgageStatistics.status.draft': '草稿',
  'search.mortgageStatistics.status.pending': '待审批',
  'search.mortgageStatistics.status.approved': '已通过',
  'search.mortgageStatistics.status.rejected': '已拒绝',
  'search.mortgageStatistics.status.overdue': '逾期',
  'search.mortgageStatistics.risk.critical': '极高风险',
  'search.mortgageStatistics.risk.high': '高风险',
  'search.mortgageStatistics.risk.medium': '中风险',
  'search.mortgageStatistics.risk.low': '低风险',
  'search.mortgageStatistics.risk.levelWithDays': '{level}（{days}天+）',
  'search.mortgageStatistics.column.building': '楼栋',
  'search.mortgageStatistics.column.buildingName': '楼栋名称',
  'search.mortgageStatistics.column.floor': '楼层',
  'search.mortgageStatistics.column.structure': '结构',
  'search.mortgageStatistics.column.houseNumber': '房号',
  'search.mortgageStatistics.column.parkingNumber': '车位编号',
  'search.mortgageStatistics.column.owner': '业主',
  'search.mortgageStatistics.column.overdueStartDate': '逾期时间',
  'search.mortgageStatistics.column.overdueDays': '逾期天数',
  'search.mortgageStatistics.column.overdueAmount': '逾期总额',
  'search.mortgageStatistics.column.riskLevel': '风险等级',
  'search.mortgageStatistics.tooltip.overdueStart':
    '最早未缴费记录创建：{date}（满 {days} 天后起算）',
  'search.mortgageStatistics.unit.days': '{days} 天',
  'search.mortgageStatistics.search.keyword': '关键词',
  'search.mortgageStatistics.search.placeholderMortgage':
    '搜索楼栋、房号、业主姓名或电话',
  'search.mortgageStatistics.search.placeholderCar':
    '搜索楼栋、结构、车位编号、业主姓名或电话',
  'search.mortgageStatistics.modal.titleMortgage':
    '{building} {floor} 房号 {houseNumber} 还款记录',
  'search.mortgageStatistics.modal.titleCar':
    '{building} {structure} 车位 {parkingNumber} 还款记录',
  'search.mortgageStatistics.label.totalAmountMortgage': '房屋总还款金额：',
  'search.mortgageStatistics.label.totalAmountCar': '车位总还款金额：',
  'search.mortgageStatistics.detail.column.code': '还款编号',
  'search.mortgageStatistics.detail.column.billingPeriod': '账期',
  'search.mortgageStatistics.detail.column.type': '类型',
  'search.mortgageStatistics.detail.column.amount': '还款金额',
  'search.mortgageStatistics.detail.column.bank': '银行',
  'search.mortgageStatistics.detail.column.status': '状态',
  'search.mortgageStatistics.detail.column.createdTime': '创建时间',
  // Service - HouseSelector
  'service.houseSelector.modal.title': '选择房屋',
  'service.houseSelector.action.confirm': '确认选择',
  'service.houseSelector.tree.title': '楼栋楼层选择',
  'service.houseSelector.table.title': '房屋列表',
  'service.houseSelector.column.select': '选择',
  'service.houseSelector.column.floor': '楼层',
  'service.houseSelector.column.houseNumber': '房号',
  'service.houseSelector.column.ownerName': '业主姓名',
  'service.houseSelector.column.ownerPhone': '业主电话',
  'service.houseSelector.column.area': '房屋面积',
  'service.houseSelector.pagination.total':
    '第 {start}-{end} 条/总共 {total} 条',
  'service.houseSelector.table.empty.forBuilding': '该楼栋/楼层暂无房屋数据',
  'service.houseSelector.table.empty.noSelection': '请先选择楼栋或楼层',
  'service.houseSelector.error.loadTree': '加载楼栋楼层数据失败',
  'service.houseSelector.error.loadHouses': '加载房屋列表失败',
  'service.houseSelector.message.selectHouse': '请选择一个房屋',
  // Financial Report
  'finance.financialReport.pageTitle': '财务报表',
  'finance.financialReport.pageSubTitle': '综合财务数据分析与统计',
  'finance.financialReport.filter.reportType': '报表类型',
  'finance.financialReport.filter.reportType.monthly': '月度报表',
  'finance.financialReport.filter.reportType.quarterly': '季度报表',
  'finance.financialReport.filter.reportType.yearly': '年度报表',
  'finance.financialReport.filter.billingPeriod': '账期',
  'finance.financialReport.filter.projectName': '项目名称',
  'finance.financialReport.filter.projectName.placeholder': '请选择项目',
  'finance.financialReport.filter.bankStatement': '银行账单',
  'finance.financialReport.filter.bankStatement.placeholder': '请选择银行账单',
  'finance.financialReport.filter.startDate': '开始日期',
  'finance.financialReport.filter.endDate': '结束日期',
  'finance.financialReport.filter.building': '楼栋',
  'finance.financialReport.filter.building.all': '全部楼栋',
  'finance.financialReport.filter.generate': '生成报表',
  'finance.financialReport.tab.overview': '综合概览',
  'finance.financialReport.tab.income': '收入分析',
  'finance.financialReport.tab.expense': '支出分析',
  'finance.financialReport.tab.mortgage': '房贷还款',
  'finance.financialReport.tab.parking': '车位还款',
  'finance.financialReport.tab.budget': '预算申请',
  'finance.financialReport.overview.loading': '正在加载综合统计数据...',
  'finance.financialReport.overview.stat.totalIncome': '总收入',
  'finance.financialReport.overview.stat.totalIncomeDesc': '共 {count} 笔收入',
  'finance.financialReport.overview.stat.totalExpense': '总支出',
  'finance.financialReport.overview.stat.totalExpenseDesc': '共 {count} 笔支出',
  'finance.financialReport.overview.stat.netCashFlow': '净现金流',
  'finance.financialReport.overview.stat.surplusStatus': '盈余状态',
  'finance.financialReport.overview.stat.lossStatus': '亏损状态',
  'finance.financialReport.overview.stat.dimension': '统计维度',
  'finance.financialReport.overview.stat.dimensionDesc': '项目 {projectCount} 个，账单 {billCount} 个',
  'finance.financialReport.overview.common.unknownProject': '未知项目',
  'finance.financialReport.overview.common.unknownBill': '未知账单',
  'finance.financialReport.overview.card.projectIncomeExpenseDistribution': '项目收支分布',
  'finance.financialReport.overview.card.bankStatementAnalysis': '银行账单分析',
  'finance.financialReport.overview.card.projectIncomeExpenseStatistics': '项目收支统计',
  'finance.financialReport.overview.card.bankStatementIncomeExpenseStatistics': '银行账单收支统计',
  'finance.financialReport.overview.empty.projectData': '暂无项目数据',
  'finance.financialReport.overview.empty.bankStatementData': '暂无银行账单数据',
  'finance.financialReport.overview.chart.projectAmountDistribution': '项目金额分布',
  'finance.financialReport.overview.table.project.columns.projectName': '项目名',
  'finance.financialReport.overview.table.bank.columns.statementNo': '银行账单号',
  'finance.financialReport.overview.table.common.columns.incomeAmount': '收入金额',
  'finance.financialReport.overview.table.common.columns.incomeCount': '收入笔数',
  'finance.financialReport.overview.table.common.columns.expenseAmount': '支出金额',
  'finance.financialReport.overview.table.common.columns.expenseCount': '支出笔数',
  'finance.financialReport.overview.table.common.columns.netIncome': '净收益',
  'finance.financialReport.overview.table.common.columns.totalCount': '总笔数',
  'finance.financialReport.export.title': '导出报表',
  'finance.financialReport.export.excel': '导出 Excel',
  'finance.financialReport.export.pdf': '导出 PDF',
  'finance.financialReport.export.chart': '导出图表',
  'finance.financialReport.export.email': '邮件发送',
  'finance.financialReport.income.stats.totalIncome': '总收入金额',
  'finance.financialReport.income.stats.approvedCountDesc': '共 {count} 笔已审批',
  'finance.financialReport.income.stats.incomeCount': '收入项目数',
  'finance.financialReport.income.stats.approvedOnlyDesc': '已审批 {count} 笔',
  'finance.financialReport.income.stats.completionRate': '审批完成率',
  'finance.financialReport.income.stats.approvedRatioDesc': '{approved}/{total} 已审批',
  'finance.financialReport.income.stats.incomeTypeCount': '收入类型数',
  'finance.financialReport.income.stats.incomeTypeCoverDesc': '涵盖 {count} 种类型',
  'finance.financialReport.income.unknownType': '未知类型',
  'finance.financialReport.income.chart.incomeDistribution': '收入分布',
  'finance.financialReport.income.column.incomeType': '收入类型',
  'finance.financialReport.income.column.totalAmount': '总金额',
  'finance.financialReport.income.column.totalCount': '总笔数',
  'finance.financialReport.income.column.pendingAmount': '待审批金额',
  'finance.financialReport.income.column.pendingCount': '待审批笔数',
  'finance.financialReport.income.column.approvedAmount': '已审批金额',
  'finance.financialReport.income.column.approvedCount': '已审批笔数',
  'finance.financialReport.income.column.completionRate': '审批完成率',
  'finance.financialReport.income.loading': '正在加载收入统计数据...',
  'finance.financialReport.income.empty': '暂无收入数据',
  'finance.financialReport.income.noData': '暂无数据',
  'finance.financialReport.income.card.distribution': '收入类型分布',
  'finance.financialReport.income.card.comparison': '收入对比分析',
  'finance.financialReport.income.card.detailStats': '收入明细统计',
  'finance.financialReport.expense.stats.totalExpense': '总支出金额',
  'finance.financialReport.expense.stats.approvedCountDesc': '共 {count} 笔已审批',
  'finance.financialReport.expense.stats.expenseCount': '支出项目数',
  'finance.financialReport.expense.stats.approvedOnlyDesc': '已审批 {count} 笔',
  'finance.financialReport.expense.stats.completionRate': '审批完成率',
  'finance.financialReport.expense.stats.approvedRatioDesc': '{approved}/{total} 已审批',
  'finance.financialReport.expense.stats.expenseTypeCount': '支出类型数',
  'finance.financialReport.expense.stats.expenseTypeCoverDesc': '涵盖 {count} 种类型',
  'finance.financialReport.expense.unknownType': '未知类型',
  'finance.financialReport.expense.chart.expenseDistribution': '支出分布',
  'finance.financialReport.expense.column.expenseType': '支出类型',
  'finance.financialReport.expense.column.totalAmount': '总金额',
  'finance.financialReport.expense.column.totalCount': '总笔数',
  'finance.financialReport.expense.column.avgAmount': '平均金额',
  'finance.financialReport.expense.column.percentage': '占比',
  'finance.financialReport.expense.column.pendingAmount': '待审批金额',
  'finance.financialReport.expense.column.pendingCount': '待审批笔数',
  'finance.financialReport.expense.column.approvedAmount': '已审批金额',
  'finance.financialReport.expense.column.approvedCount': '已审批笔数',
  'finance.financialReport.expense.column.completionRate': '审批完成率',
  'finance.financialReport.expense.loading': '正在加载支出统计数据...',
  'finance.financialReport.expense.empty': '暂无支出数据',
  'finance.financialReport.expense.noData': '暂无数据',
  'finance.financialReport.expense.card.distribution': '支出类型分布',
  'finance.financialReport.expense.card.comparison': '支出对比分析',
  'finance.financialReport.expense.card.detailStats': '支出明细统计',
  'finance.financialReport.mortgage.stats.repaidAmount': '已还款总额',
  'finance.financialReport.mortgage.stats.completionRateDesc': '完成率 {rate}%',
  'finance.financialReport.mortgage.stats.pendingAmount': '待还款金额',
  'finance.financialReport.mortgage.stats.pendingCountDesc': '{count}笔待还',
  'finance.financialReport.mortgage.stats.repaymentCount': '还款笔数',
  'finance.financialReport.mortgage.stats.repaidPendingDesc': '已还 {approved}笔，待还 {pending}笔',
  'finance.financialReport.mortgage.stats.onTimeRate': '按时还款率',
  'finance.financialReport.mortgage.stats.finishedDesc': '{approved}/{total} 已完成',
  'finance.financialReport.mortgage.unknownBuilding': '未知楼栋',
  'finance.financialReport.mortgage.unknownType': '未知类型',
  'finance.financialReport.mortgage.type.mortgage': '房贷',
  'finance.financialReport.mortgage.type.rent': '租金',
  'finance.financialReport.mortgage.chart.repaymentTypeDistribution': '还款类型分布',
  'finance.financialReport.mortgage.column.building': '楼栋',
  'finance.financialReport.mortgage.column.repaymentType': '还款类型',
  'finance.financialReport.mortgage.column.totalAmount': '总金额',
  'finance.financialReport.mortgage.column.totalCount': '总笔数',
  'finance.financialReport.mortgage.column.pendingAmount': '待还款金额',
  'finance.financialReport.mortgage.column.pendingCount': '待还款笔数',
  'finance.financialReport.mortgage.column.repaidAmount': '已还款金额',
  'finance.financialReport.mortgage.column.repaidCount': '已还款笔数',
  'finance.financialReport.mortgage.column.completionRate': '完成率',
  'finance.financialReport.mortgage.loading': '正在加载房贷还款统计数据...',
  'finance.financialReport.mortgage.empty': '暂无房贷还款数据',
  'finance.financialReport.mortgage.noData': '暂无数据',
  'finance.financialReport.mortgage.card.typeDistribution': '还款类型分布',
  'finance.financialReport.mortgage.card.buildingComparison': '楼栋还款对比',
  'finance.financialReport.mortgage.card.detailStats': '房贷还款明细统计',
  'finance.financialReport.parking.stats.repaidAmount': '已还款总额',
  'finance.financialReport.parking.stats.completionRateDesc': '完成率 {rate}%',
  'finance.financialReport.parking.stats.pendingAmount': '待还款金额',
  'finance.financialReport.parking.stats.pendingCountDesc': '{count}笔待还',
  'finance.financialReport.parking.stats.repaymentCount': '还款笔数',
  'finance.financialReport.parking.stats.repaidPendingDesc': '已还 {approved}笔，待还 {pending}笔',
  'finance.financialReport.parking.stats.onTimeRate': '按时还款率',
  'finance.financialReport.parking.stats.finishedDesc': '{approved}/{total} 已完成',
  'finance.financialReport.parking.unknownBuilding': '未知楼栋',
  'finance.financialReport.parking.unknownType': '未知类型',
  'finance.financialReport.parking.type.carLoan': '车贷',
  'finance.financialReport.parking.type.rent': '租金',
  'finance.financialReport.parking.chart.repaymentTypeDistribution': '车贷还款类型分布',
  'finance.financialReport.parking.column.building': '楼栋',
  'finance.financialReport.parking.column.repaymentType': '还款类型',
  'finance.financialReport.parking.column.totalAmount': '总金额',
  'finance.financialReport.parking.column.totalCount': '总笔数',
  'finance.financialReport.parking.column.avgAmount': '平均金额',
  'finance.financialReport.parking.column.pendingAmount': '待还款金额',
  'finance.financialReport.parking.column.pendingCount': '待还款笔数',
  'finance.financialReport.parking.column.repaidAmount': '已还款金额',
  'finance.financialReport.parking.column.repaidCount': '已还款笔数',
  'finance.financialReport.parking.column.completionRate': '完成率',
  'finance.financialReport.parking.loading': '正在加载车贷还款统计数据...',
  'finance.financialReport.parking.empty': '暂无车贷还款数据',
  'finance.financialReport.parking.noData': '暂无数据',
  'finance.financialReport.parking.card.typeDistribution': '车贷还款类型分布',
  'finance.financialReport.parking.card.buildingComparison': '楼栋车贷还款对比',
  'finance.financialReport.parking.card.detailStats': '车贷还款明细统计',
  'finance.financialReport.budget.stats.totalAppliedAmount': '申请总金额',
  'finance.financialReport.budget.stats.totalCountDesc': '{count}个申请项目',
  'finance.financialReport.budget.stats.approvedAmount': '已批准金额',
  'finance.financialReport.budget.stats.executionRateDesc': '执行率 {rate}%',
  'finance.financialReport.budget.stats.pendingAmount': '待审批金额',
  'finance.financialReport.budget.stats.pendingCountDesc': '{count}个待审项目',
  'finance.financialReport.budget.stats.rejectedAmount': '已拒绝金额',
  'finance.financialReport.budget.stats.rejectedCountDesc': '{count}个拒绝项目',
  'finance.financialReport.budget.unknownType': '未知类型',
  'finance.financialReport.budget.status.approved': '已批准',
  'finance.financialReport.budget.status.pending': '待审批',
  'finance.financialReport.budget.status.rejected': '已拒绝',
  'finance.financialReport.budget.chart.statusDistribution': '预算申请状态分布',
  'finance.financialReport.budget.column.budgetType': '预算类型',
  'finance.financialReport.budget.column.totalAppliedAmount': '申请总额',
  'finance.financialReport.budget.column.totalCount': '申请笔数',
  'finance.financialReport.budget.column.avgAmount': '平均金额',
  'finance.financialReport.budget.column.approvedAmount': '已批准金额',
  'finance.financialReport.budget.column.approvedCount': '已批准笔数',
  'finance.financialReport.budget.column.pendingAmount': '待审批金额',
  'finance.financialReport.budget.column.pendingCount': '待审批笔数',
  'finance.financialReport.budget.column.rejectedAmount': '已拒绝金额',
  'finance.financialReport.budget.column.rejectedCount': '已拒绝笔数',
  'finance.financialReport.budget.column.approvalRate': '批准率',
  'finance.financialReport.budget.loading': '正在加载预算申请统计数据...',
  'finance.financialReport.budget.empty': '暂无预算申请数据',
  'finance.financialReport.budget.noData': '暂无数据',
  'finance.financialReport.budget.card.statusDistribution': '预算申请状态分布',
  'finance.financialReport.budget.card.typeComparison': '预算类型对比分析',
  'finance.financialReport.budget.card.detailStatsByType': '预算申请明细统计（按类型分组）',
  // Project Management
  'finance.project.headerTitle': '项目管理',
  'finance.project.action.create': '新建项目',
  'finance.project.confirm.delete': '确定要删除该项目吗？',
  'finance.project.confirm.batchDelete': '确定要批量删除选中的项目吗？',
  'finance.project.message.getDetailFailed': '获取详情失败',
  'finance.project.message.delete.success': '删除成功',
  'finance.project.message.delete.failed': '删除失败',
  'finance.project.message.batchDelete.success': '批量删除成功',
  'finance.project.message.batchDelete.failed': '批量删除失败',
  'finance.project.message.update.success': '更新成功',
  'finance.project.message.update.failed': '更新失败',
  'finance.project.message.create.success': '创建成功',
  'finance.project.message.create.failed': '创建失败',
  'finance.project.column.type': '类型关联',
  'finance.project.column.projectName': '项目名称',
  'finance.project.column.loanBank': '贷款收款银行',
  'finance.project.column.propertyFeeBank': '物业费收款银行',
  'finance.project.column.normalReceiveBank': '普通收款银行',
  'finance.project.column.status': '状态',
  'finance.project.column.sort': '排序',
  'finance.project.column.action': '操作',
  'finance.project.status.enabled': '启用',
  'finance.project.status.disabled': '禁用',
  'finance.project.action.view': '查看',
  'finance.project.action.edit': '编辑',
  'finance.project.action.delete': '删除',
  'finance.project.action.batchDelete': '批量删除',
  'finance.project.action.ok': '确定',
  'finance.project.action.cancel': '取消',
  'finance.project.action.close': '关闭',
  'finance.project.table.selected': '已选择 {count} 项',
  'finance.project.table.clearSelected': '取消选择',
  'finance.project.modal.detailTitle': '项目详情',
  'finance.project.label.type': '类型关联',
  'finance.project.label.projectName': '项目名称',
  'finance.project.label.sort': '排序',
  'finance.project.label.status': '状态',
  'finance.project.label.loanBank': '贷款收款银行',
  'finance.project.label.propertyFeeBank': '物业费收款银行',
  'finance.project.label.normalReceiveBank': '普通收款银行',
  'finance.project.label.remarks': '备注',
  'finance.project.label.createdTime': '创建时间',
  'finance.project.label.updatedTime': '更新时间',
  'finance.project.drawer.title.edit': '编辑项目',
  'finance.project.drawer.title.create': '新建项目',
  'finance.project.form.type.label': '类型关联',
  'finance.project.form.type.placeholder': '请选择类型关联',
  'finance.project.form.projectName.label': '项目名称',
  'finance.project.form.projectName.placeholder': '请输入项目名称',
  'finance.project.form.projectName.required': '请输入项目名称',
  'finance.project.form.loanBank.label': '贷款收款银行',
  'finance.project.form.loanBank.placeholder': '请选择贷款收款银行',
  'finance.project.form.propertyFeeBank.label': '物业费收款银行',
  'finance.project.form.propertyFeeBank.placeholder': '请选择物业费收款银行',
  'finance.project.form.normalReceiveBank.label': '普通收款银行',
  'finance.project.form.normalReceiveBank.placeholder': '请选择普通收款银行',
  'finance.project.form.loanBankStatement.label': '贷款银行账单',
  'finance.project.form.loanBankStatement.placeholder': '请选择贷款银行账单',
  'finance.project.form.propertyFeeBankStatement.label': '物业费银行账单',
  'finance.project.form.propertyFeeBankStatement.placeholder':
    '请选择物业费银行账单',
  'finance.project.form.normalReceiveBankStatement.label': '普通收款银行账单',
  'finance.project.form.normalReceiveBankStatement.placeholder':
    '请选择普通收款银行账单',
  'finance.project.form.status.label': '状态',
  'finance.project.form.status.required': '请选择状态',
  'finance.project.form.sort.label': '排序',
  'finance.project.form.sort.placeholder': '请输入排序',
  'finance.project.form.sort.required': '请输入排序',
  'finance.project.form.remarks.label': '备注',
  'finance.project.form.remarks.placeholder': '请输入备注信息',
  'finance.project.column.loanBankStatement': '贷款银行账单',
  'finance.project.column.propertyFeeBankStatement': '物业费银行账单',
  'finance.project.column.normalReceiveBankStatement': '普通收款银行账单',
  'finance.project.label.loanBankStatement': '贷款银行账单',
  'finance.project.label.propertyFeeBankStatement': '物业费银行账单',
  'finance.project.label.normalReceiveBankStatement': '普通收款银行账单',
  // Bank Management
  'finance.bank.headerTitle': '银行管理',
  'finance.bank.action.create': '新建银行',
  'finance.bank.confirm.toggleStatus.disable': '确定要停用这个银行吗？',
  'finance.bank.confirm.toggleStatus.enable': '确定要启用这个银行吗？',
  'finance.bank.message.getDetailFailed': '获取银行详情失败',
  'finance.bank.message.toggleStatus.enable.success': '启用成功',
  'finance.bank.message.toggleStatus.disable.success': '停用成功',
  'finance.bank.message.toggleStatus.enable.failed': '启用失败',
  'finance.bank.message.toggleStatus.disable.failed': '停用失败',
  'finance.bank.message.create.success': '创建成功',
  'finance.bank.message.update.success': '更新成功',
  'finance.bank.column.logoUrl': '银行Logo',
  'finance.bank.column.bankName': '银行名称',
  'finance.bank.column.bankName.required': '银行名称为必填项',
  'finance.bank.column.bankNickname': '银行昵称',
  'finance.bank.column.bankNickname.required': '请输入银行昵称',
  'finance.bank.column.currency': '币种',
  'finance.bank.column.purposeDesc': '用途描述',
  'finance.bank.column.lastAmount': '快照金额',
  'finance.bank.column.lastUpdateTime': '快照时间',
  'finance.bank.column.isPayment': '手机端收款',
  'finance.bank.column.status': '状态',
  'finance.bank.column.sort': '排序',
  'finance.bank.column.remarks': '备注',
  'finance.bank.column.action': '操作',
  'finance.bank.status.enabled': '启用',
  'finance.bank.status.disabled': '停用',
  'finance.bank.status.unknown': '未知',
  'finance.bank.isPayment.yes': '是',
  'finance.bank.isPayment.no': '否',
  'finance.bank.action.view': '查看',
  'finance.bank.action.edit': '编辑',
  'finance.bank.action.enable': '启用',
  'finance.bank.action.disable': '停用',
  'finance.bank.action.ok': '确定',
  'finance.bank.action.cancel': '取消',
  'finance.bank.action.close': '关闭',
  'finance.bank.modal.createTitle': '新建银行',
  'finance.bank.modal.editTitle': '编辑银行',
  'finance.bank.modal.detailTitle': '银行详情',
  'finance.bank.label.bankName': '银行名称',
  'finance.bank.label.bankCode': '银行昵称',
  'finance.bank.label.bankNickname': '银行昵称',
  'finance.bank.label.currency': '币种',
  'finance.bank.label.accountNumber': '银行账号',
  'finance.bank.label.accountHolder': '收款人',
  'finance.bank.label.isPayment': '手机端收款',
  'finance.bank.label.status': '状态',
  'finance.bank.label.logoUrl': '银行Logo',
  'finance.bank.label.purposeDesc': '用途描述',
  'finance.bank.label.remarks': '备注',
  'finance.bank.label.createdTime': '创建时间',
  'finance.bank.label.updatedTime': '更新时间',
  // Bank Form
  'finance.bank.form.message.getDetailFailed': '获取银行详情失败',
  'finance.bank.form.message.updateFailed': '更新失败',
  'finance.bank.form.message.createFailed': '创建失败',
  'finance.bank.form.message.bankAddedSuccess': '银行添加成功',
  'finance.bank.form.message.logoUploadSuccess': 'Logo上传成功',
  'finance.bank.form.message.logoUploadFailed': 'Logo上传失败',
  'finance.bank.form.message.imageOnly': '只能上传图片文件!',
  'finance.bank.form.message.imageSizeLimit': '图片大小不能超过2MB!',
  'finance.bank.form.bankName.label': '银行名称',
  'finance.bank.form.bankName.placeholder': '请输入银行名称',
  'finance.bank.form.bankName.required': '请输入银行名称',
  'finance.bank.form.bankName.max': '银行名称长度不能超过100个字符',
  'finance.bank.form.bankCode.label': '银行昵称',
  'finance.bank.form.bankCode.placeholder': '请输入银行昵称',
  'finance.bank.form.bankCode.required': '请输入银行昵称',
  'finance.bank.form.bankCode.max': '银行昵称长度不能超过50个字符',
  'finance.bank.form.bankSelector.label': '银行名称',
  'finance.bank.form.bankSelector.placeholder': '请选择银行名称',
  'finance.bank.form.bankSelector.required': '请选择银行名称',
  'finance.bank.form.bankSelector.addBank': '添加',
  'finance.bank.form.accountNumber.label': '银行账号',
  'finance.bank.form.accountNumber.placeholder': '请输入银行账号',
  'finance.bank.form.accountNumber.max': '银行账号长度不能超过50个字符',
  'finance.bank.form.accountNumber.exists': '该银行账号已存在，请检查是否重复录入',
  'finance.bank.form.accountHolder.label': '收款人',
  'finance.bank.form.accountHolder.placeholder': '请输入收款人',
  'finance.bank.form.accountHolder.max': '收款人长度不能超过100个字符',
  'finance.bank.form.currency.label': '币种',
  'finance.bank.form.currency.placeholder': '请选择币种',
  'finance.bank.form.currency.required': '请选择币种',
  'finance.bank.form.isPayment.label': '手机端收款',
  'finance.bank.form.isPayment.placeholder': '请选择手机端收款',
  'finance.bank.form.isPayment.required': '请选择手机端收款',
  'finance.bank.form.sort.label': '排序',
  'finance.bank.form.sort.placeholder': '请输入排序值',
  'finance.bank.form.sort.invalid': '请输入有效的数字',
  'finance.bank.form.status.label': '状态',
  'finance.bank.form.status.placeholder': '请选择状态',
  'finance.bank.form.status.required': '请选择状态',
  'finance.bank.form.logoUrl.label': '银行Logo',
  'finance.bank.form.logoUrl.uploadText': '拖拽或点击上传',
  'finance.bank.form.logoUrl.changeText': '拖拽或点击更换图片',
  'finance.bank.form.logoUrl.uploading': '上传中',
  'finance.bank.form.logoUrl.hint': '支持JPG/PNG/GIF/WEBP格式，最大2MB',
  'finance.bank.form.purposeDesc.label': '用途描述',
  'finance.bank.form.purposeDesc.placeholder': '请输入用途描述',
  'finance.bank.form.purposeDesc.max': '用途描述长度不能超过500个字符',
  'finance.bank.form.remarks.label': '备注',
  'finance.bank.form.remarks.placeholder': '请输入备注信息',
  'finance.bank.form.remarks.max': '备注长度不能超过500个字符',
  'finance.bank.form.submit.update': '更新',
  'finance.bank.form.submit.create': '创建',
  'finance.bank.form.submit.cancel': '取消',
  // Bank Snapshot Modal
  'finance.bank.snapshot.modal.title': '银行卡每月快照管理',
  'finance.bank.snapshot.modal.addTitle': '新增快照',
  'finance.bank.snapshot.modal.previewTitle': '快照图片预览',
  'finance.bank.snapshot.label.bankName': '银行名称',
  'finance.bank.snapshot.label.bankCode': '银行昵称',
  'finance.bank.snapshot.label.currency': '币种',
  'finance.bank.snapshot.label.sort': '排序',
  'finance.bank.snapshot.label.accountNumber': '银行账号',
  'finance.bank.snapshot.label.accountHolder': '收款人',
  'finance.bank.snapshot.label.purposeDesc': '用途描述',
  'finance.bank.snapshot.label.remarks': '备注',
  'finance.bank.snapshot.section.title': '快照记录历史',
  'finance.bank.snapshot.section.hint': '超过半小时快照记录，将不允许删除',
  'finance.bank.snapshot.action.refresh': '刷新',
  'finance.bank.snapshot.action.add': '添加快照',
  'finance.bank.snapshot.action.view': '查看',
  'finance.bank.snapshot.action.delete': '删除',
  'finance.bank.snapshot.confirm.delete': '确定删除该快照吗？',
  'finance.bank.snapshot.message.getListFailed': '获取快照记录失败',
  'finance.bank.snapshot.message.deleteSuccess': '删除成功',
  'finance.bank.snapshot.message.deleteFailed': '删除失败',
  'finance.bank.snapshot.message.noImage': '暂无快照图片',
  'finance.bank.snapshot.message.createSuccess': '新增快照成功',
  'finance.bank.snapshot.message.createFailed': '新增快照失败',
  'finance.bank.snapshot.message.uploadSuccess': '上传成功',
  'finance.bank.snapshot.message.imageOnly': '仅支持上传图片文件',
  'finance.bank.snapshot.message.imageSizeLimit': '图片大小不能超过5MB',
  'finance.bank.snapshot.message.uploadImageFirst': '请先上传快照图片',
  'finance.bank.snapshot.message.bankNotFound': '未找到银行信息',
  'finance.bank.snapshot.empty': '暂无快照记录',
  'finance.bank.snapshot.empty.image': '暂无图片',
  'finance.bank.snapshot.pagination.total': '共 {total} 条',
  'finance.bank.snapshot.form.recordDate.label': '记录日期',
  'finance.bank.snapshot.form.recordDate.required': '请选择记录日期',
  'finance.bank.snapshot.form.amount.label': '当前余额 (PHP)',
  'finance.bank.snapshot.form.amount.placeholder': '请输入余额金额',
  'finance.bank.snapshot.form.amount.required': '请输入余额金额',
  'finance.bank.snapshot.form.remark.label': '备注说明',
  'finance.bank.snapshot.form.remark.placeholder': '如有特殊情况可在此说明',
  'finance.bank.snapshot.form.image.label': '快照图片 (支持 JPG/PNG，≤5MB)',
  'finance.bank.snapshot.form.image.uploadText': '点击或拖拽上传银行卡余额截图',
  'finance.bank.snapshot.form.image.hint':
    '支持 JPG、PNG 格式，文件大小不超过 5MB',
  'finance.bank.snapshot.form.submit': '提交快照',
  'finance.bank.snapshot.form.reset': '重置',
  // Bank Statement - Additional translations
  'finance.bankStatement.column.reviewer': '审核人',
  'finance.bankStatement.column.reviewTime': '审核时间',
  'finance.bankStatement.column.reviewIp': '操作IP',
  'finance.bankStatement.action.settle': '结算',
  'finance.bankStatement.tab.detail': '账单详情',
  'finance.bankStatement.tab.expenses': '账单明细',
  'finance.bankStatement.expenses.includeUnsettled': '包含未通过订单：',
  'finance.bankStatement.expenses.total': '共 {count} 条明细',
  'finance.bankStatement.expenses.column.code': '编号',
  'finance.bankStatement.expenses.column.name': '名称',
  'finance.bankStatement.expenses.column.type': '类型',
  'finance.bankStatement.expenses.column.amountType': '收支类型',
  'finance.bankStatement.expenses.column.amount': '金额',
  'finance.bankStatement.expenses.column.status': '状态',
  'finance.bankStatement.expenses.column.createdTime': '创建时间',
  'finance.bankStatement.expenses.amountType.in': '收入',
  'finance.bankStatement.expenses.amountType.out': '支出',
  'finance.bankStatement.expenses.status.draft': '草稿',
  'finance.bankStatement.expenses.status.pending': '待审核',
  'finance.bankStatement.expenses.status.approved': '已通过',
  'finance.bankStatement.expenses.status.rejected': '已拒绝',
  'finance.bankStatement.expenses.pagination.total': '共 {total} 条',
  'finance.bankStatement.expenses.loadFailed': '加载账单明细失败',
  'finance.bankStatement.switch.yes': '是',
  'finance.bankStatement.switch.no': '否',
  // Budget Request - Additional translations
  'finance.budgetRequest.column.projectName': '项目名称',
  'finance.budgetRequest.column.budgetType': '预算类型',
  'finance.budgetRequest.column.applyUser': '申请人',
  'finance.budgetRequest.column.payeeUser': '受益人',
  'finance.budgetRequest.label.budgetType': '预算类型',
  'finance.budgetRequest.label.projectName': '项目名称',
  'finance.budgetRequest.label.applyUser': '申请人',
  'finance.budgetRequest.label.payeeUser': '受益人',
  'finance.budgetRequest.form.budgetType.label': '预算类型',
  'finance.budgetRequest.form.budgetType.placeholder': '请选择预算类型',
  'finance.budgetRequest.form.budgetType.required': '请选择预算类型',
  'finance.budgetRequest.form.projectName.label': '项目名称',
  'finance.budgetRequest.form.projectName.placeholder': '请选择项目名称',
  'finance.budgetRequest.form.applyUser.label': '申请人',
  'finance.budgetRequest.form.applyUser.placeholder': '请输入申请人姓名',
  'finance.budgetRequest.form.applyUser.max': '申请人姓名不能超过100个字符',
  'finance.budgetRequest.form.payeeUser.label': '受益人',
  'finance.budgetRequest.form.payeeUser.placeholder': '请输入受益人姓名',
  'finance.budgetRequest.form.payeeUser.max': '受益人姓名不能超过100个字符',
  'finance.budgetRequest.form.applyRemark.label': '申请说明',
  'finance.budgetRequest.form.applyRemark.placeholder': '请输入申请说明',
  'finance.budgetRequest.form.applyRemark.max': '申请说明不能超过500个字符',
  'finance.budgetRequest.form.remarks.label': '备注',
  'finance.budgetRequest.form.remarks.placeholder': '请输入备注信息',
  'finance.budgetRequest.form.remarks.max': '备注不能超过500个字符',
  'finance.budgetRequest.section.relatedInfo': '关联信息',
  'finance.budgetRequest.section.personnelInfo': '人员信息',
  'finance.budgetRequest.upload.multipleSupport':
    '支持多文件上传，可同时选择多个文件',
  'finance.budgetRequest.message.loadBudgetTypeFailed': '加载预算类型字典失败',
  'finance.budgetRequest.message.loadProjectNameFailed': '加载项目名称失败',
  'finance.budgetRequest.message.searchBankStatementFailed': '搜索银行账单失败',
  'finance.budgetRequest.message.getBankStatementDetailFailed':
    '获取银行账单详情失败',
  'finance.budgetRequest.message.getAuditRecordsFailed': '获取审核记录失败',
  'finance.budgetRequest.fileFormat.unknown': '未知',
  // Mortgage Pay - Additional translations
  'finance.mortgagePay.column.projectName': '项目名称',
  'finance.mortgagePay.label.projectName': '项目名称',
  'finance.mortgagePay.form.paymentType.label': '还款类型',
  'finance.mortgagePay.form.paymentType.placeholder': '请选择还款类型',
  'finance.mortgagePay.form.paymentType.required': '请选择还款类型',
  'finance.mortgagePay.form.paymentType.mortgage': '月供',
  'finance.mortgagePay.form.paymentType.rent': '月租',
  'finance.mortgagePay.form.projectName.label': '项目名称',
  'finance.mortgagePay.form.projectName.placeholder': '请选择项目名称',
  'finance.mortgagePay.section.relatedInfo': '关联信息',
  'finance.mortgagePay.upload.multipleSupport':
    '支持多文件上传，可同时选择多个文件',
  'finance.mortgagePay.message.loadProjectNameFailed': '加载项目名称失败',
  'finance.mortgagePay.message.searchBankStatementFailed': '搜索银行账单失败',
  'finance.mortgagePay.message.getBankStatementDetailFailed':
    '获取银行账单详情失败',
  'finance.mortgagePay.message.getAuditRecordsFailed': '获取审核记录失败',
  'finance.mortgagePay.message.getProjectIdFailed': '获取项目ID失败',
  'finance.mortgagePay.message.paymentTypeChanged':
    '还款类型已更改，请重新选择房屋以更新金额',
  'finance.mortgagePay.message.batchCreateFailed.console':
    '批量创建还款记录失败',
  'finance.mortgagePay.form.house.selectPrompt': '请选择房屋',
  'finance.mortgagePay.upload.error.uploadFormat': '上传响应格式错误',
  // Daily Report
  'finance.dailyReport.tab.daily': '每日对账',
  'finance.dailyReport.tab.monthly': '每月对账',
  'finance.dailyReport.headerTitle': '每日对账报表',
  'finance.dailyReport.action.generate': '生成报表',
  'finance.dailyReport.action.batchGenerate': '批量生成',
  'finance.dailyReport.action.viewDetail': '查看明细',
  'finance.dailyReport.column.reportDate': '报表日期',
  'finance.dailyReport.column.bankName': '银行名称',
  'finance.dailyReport.column.totalIncome': '总收入',
  'finance.dailyReport.column.incomeCount': '收入笔数',
  'finance.dailyReport.column.totalExpense': '总支出',
  'finance.dailyReport.column.expenseCount': '支出笔数',
  'finance.dailyReport.column.netAmount': '净额',
  'finance.dailyReport.column.action': '操作',
  'finance.dailyReport.bankName.cash': '现金',
  'finance.dailyReport.modal.generateTitle': '生成每日报表',
  'finance.dailyReport.modal.batchGenerateTitle': '批量生成每日报表',
  'finance.dailyReport.form.reportDate.label': '报表日期',
  'finance.dailyReport.form.reportDate.required': '请选择报表日期',
  'finance.dailyReport.form.dateRange.label': '日期范围',
  'finance.dailyReport.form.dateRange.required': '请选择日期范围',
  'finance.dailyReport.message.generateSuccess': '生成每日报表成功',
  'finance.dailyReport.message.generateFailed': '生成每日报表失败',
  'finance.dailyReport.message.batchGenerateSuccess': '批量生成每日报表成功',
  'finance.dailyReport.message.batchGenerateFailed': '批量生成每日报表失败',
  'finance.dailyReport.message.regenerateSuccess': '重新生成报表成功',
  'finance.dailyReport.message.regenerateFailed': '重新生成报表失败',
  'finance.dailyReport.message.loadBankListFailed': '加载银行列表失败',
  'finance.dailyReport.confirm.regenerateTitle': '确认重新生成',
  'finance.dailyReport.confirm.regenerateContent':
    '确定要重新生成 {date} 的报表吗？这将覆盖已有数据。',
  // Daily Report Detail
  'finance.dailyReport.detail.title': '每日对账明细',
  'finance.dailyReport.detail.column.statementNo': '银行账单',
  'finance.dailyReport.detail.column.code': '编号',
  'finance.dailyReport.detail.column.name': '明细名称',
  'finance.dailyReport.detail.column.projectName': '项目名称',
  'finance.dailyReport.detail.column.type': '类型',
  'finance.dailyReport.detail.column.amountType': '收支类型',
  'finance.dailyReport.detail.column.amount': '金额',
  'finance.dailyReport.detail.column.fileUrl': '相关文件',
  'finance.dailyReport.detail.column.status': '状态',
  'finance.dailyReport.detail.column.createdTime': '创建时间',
  'finance.dailyReport.detail.amountType.in': '收入',
  'finance.dailyReport.detail.amountType.out': '支出',
  'finance.dailyReport.detail.status.approved': '已通过',
  'finance.dailyReport.detail.status.pending': '待审核',
  'finance.dailyReport.detail.status.rejected': '已拒绝',
  'finance.dailyReport.detail.status.draft': '草稿',
  'finance.dailyReport.detail.pagination.total': '共 {total} 条',
  'finance.dailyReport.detail.message.loadTypeDictFailed': '加载类型字典失败',
  'finance.dailyReport.detail.message.getDetailsFailed': '获取明细失败',
  'finance.dailyReport.summary.currentPage': '当前页汇总',
  'finance.dailyReport.summary.allPages': '全部页汇总',
  // Monthly Report
  'finance.monthlyReport.headerTitle': '每月对账报表',
  'finance.monthlyReport.action.generate': '生成报表',
  'finance.monthlyReport.action.batchGenerate': '批量生成',
  'finance.monthlyReport.action.viewDetail': '查看明细',
  'finance.monthlyReport.column.reportPeriod': '报表账期',
  'finance.monthlyReport.column.bankName': '银行名称',
  'finance.monthlyReport.column.totalIncome': '总收入',
  'finance.monthlyReport.column.incomeCount': '收入笔数',
  'finance.monthlyReport.column.totalExpense': '总支出',
  'finance.monthlyReport.column.expenseCount': '支出笔数',
  'finance.monthlyReport.column.netAmount': '净额',
  'finance.monthlyReport.column.action': '操作',
  'finance.monthlyReport.bankName.cash': '现金',
  'finance.monthlyReport.modal.generateTitle': '生成月度报表',
  'finance.monthlyReport.modal.batchGenerateTitle': '批量生成月度报表',
  'finance.monthlyReport.form.reportPeriod.label': '报表账期',
  'finance.monthlyReport.form.reportPeriod.required': '请选择报表账期',
  'finance.monthlyReport.form.periodRange.label': '账期范围',
  'finance.monthlyReport.form.periodRange.required': '请选择账期范围',
  'finance.monthlyReport.message.generateSuccess': '生成月度报表成功',
  'finance.monthlyReport.message.generateFailed': '生成月度报表失败',
  'finance.monthlyReport.message.batchGenerateSuccess': '批量生成月度报表成功',
  'finance.monthlyReport.message.batchGenerateFailed': '批量生成月度报表失败',
  'finance.monthlyReport.message.regenerateSuccess': '重新生成报表成功',
  'finance.monthlyReport.message.regenerateFailed': '重新生成报表失败',
  'finance.monthlyReport.message.loadBankListFailed': '加载银行列表失败',
  'finance.monthlyReport.confirm.regenerateTitle': '确认重新生成',
  'finance.monthlyReport.confirm.regenerateContent':
    '确定要重新生成 {period} 的报表吗？这将覆盖已有数据。',
  // Monthly Report Detail
  'finance.monthlyReport.detail.title': '每月对账明细',
  'finance.monthlyReport.detail.column.statementNo': '银行账单',
  'finance.monthlyReport.detail.column.code': '编号',
  'finance.monthlyReport.detail.column.name': '明细名称',
  'finance.monthlyReport.detail.column.projectName': '项目名称',
  'finance.monthlyReport.detail.column.type': '类型',
  'finance.monthlyReport.detail.column.amountType': '收支类型',
  'finance.monthlyReport.detail.column.amount': '金额',
  'finance.monthlyReport.detail.column.fileUrl': '相关文件',
  'finance.monthlyReport.detail.column.status': '状态',
  'finance.monthlyReport.detail.column.createdTime': '创建时间',
  'finance.monthlyReport.detail.amountType.in': '收入',
  'finance.monthlyReport.detail.amountType.out': '支出',
  'finance.monthlyReport.detail.status.approved': '已通过',
  'finance.monthlyReport.detail.status.pending': '待审核',
  'finance.monthlyReport.detail.status.rejected': '已拒绝',
  'finance.monthlyReport.detail.status.draft': '草稿',
  'finance.monthlyReport.detail.pagination.total': '共 {total} 条',
  'finance.monthlyReport.detail.message.loadTypeDictFailed': '加载类型字典失败',
  'finance.monthlyReport.detail.message.getDetailsFailed': '获取明细失败',
  'finance.monthlyReport.summary.currentPage': '当前页汇总',
  'finance.monthlyReport.summary.allPages': '全部页汇总',
  'finance.pricing_review.action.review': '核价',
};
